import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

// FontAwesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// WebAwesome.
import WaButton from '@web.awesome.me/webawesome-pro/dist/react/button';

// Styled.
import * as S from './styled';

// Shown over the skeleton, so the page does not jump from the skeleton to a different layout.
const MissingResource = ({ list, title, skeleton = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <S.Wrapper>
      {skeleton && <S.Backdrop aria-hidden>{skeleton}</S.Backdrop>}
      <S.Card>
        <S.Gif />
        <S.Title>{t('core:error.notFound.title')}</S.Title>
        <p>{t('core:error.missingResource.message')}</p>
        <WaButton variant="brand" onClick={() => navigate(list)}>
          <FontAwesomeIcon slot="start" icon={byPrefixAndName.fal['arrow-left']} />
          {t('core:error.missingResource.back', { title: t(title) })}
        </WaButton>
      </S.Card>
    </S.Wrapper>
  );
};

MissingResource.propTypes = {
  list: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  skeleton: PropTypes.node,
};

export default MissingResource;
